'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var tocasProps = [
// semantics
'primary', 'info', 'warning', 'positive', 'negative', 'inverted',
// annoucements
'secondary', 'tertiary',
// sizes
'mini', 'tiny', 'small', 'medium', 'large', 'big', 'huge', 'massive',
// directions
'top', 'middle', 'bottom', 'left', 'center', 'right',
// alignment
'floated', 'aligned', 'attached',
// active/disabled
'active', 'disabled',
// others
'icon'];

var Box = function (_Component) {
  _inherits(Box, _Component);

  function Box() {
    _classCallCheck(this, Box);

    return _possibleConstructorReturn(this, (Box.__proto__ || Object.getPrototypeOf(Box)).apply(this, arguments));
  }

  _createClass(Box, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          wrapper = _props.wrapper,
          className = _props.className,
          children = _props.children,
          ts = _props.ts,
          vertically = _props.vertically,
          horizontally = _props.horizontally,
          very = _props.very,
          extra = _props.extra,
          padded = _props.padded,
          fitted = _props.fitted,
          compact = _props.compact,
          rest = _objectWithoutProperties(_props, ['wrapper', 'className', 'children', 'ts', 'vertically', 'horizontally', 'very', 'extra', 'padded', 'fitted', 'compact']);

      var cx = _classnames2.default.apply(undefined, [{
        ts: ts,
        vertically: vertically,
        horizontally: horizontally,
        very: very,
        extra: extra,
        padded: padded,
        fitted: fitted,
        compact: compact
      }].concat(_toConsumableArray(tocasProps.map(function (tocasProp) {
        var cx = _defineProperty({}, tocasProp, rest[tocasProp]);
        delete rest[tocasProp];

        return cx;
      })), [className]));

      return _react2.default.createElement(wrapper, _extends({
        className: cx
      }, rest), children);
    }
  }]);

  return Box;
}(_react.Component);

Box.displayName = 'Box';

Box.defaultProps = {
  wrapper: 'div'
};

Box.propTypes = _extends({
  wrapper: _propTypes2.default.node.isRequired
}, Object.assign.apply(Object, [{}].concat(_toConsumableArray(tocasProps.map(function (tocasProp) {
  return _defineProperty({}, tocasProp, _propTypes2.default.bool);
})))));

exports.default = Box;
//# sourceMappingURL=data:application/json;charset=utf8;base64,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



//////////////////
// WEBPACK FOOTER
// ../lib/Box.js
// module id = 16
// module chunks = 0